import { render, staticRenderFns } from "./LcSummaryPanel.vue?vue&type=template&id=5c70b32d&scoped=true"
import script from "./LcSummaryPanel.vue?vue&type=script&lang=js"
export * from "./LcSummaryPanel.vue?vue&type=script&lang=js"
import style0 from "./LcSummaryPanel.vue?vue&type=style&index=0&id=5c70b32d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c70b32d",
  null
  
)

export default component.exports